import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Residence} from "./Residence";

@Injectable({ providedIn: 'root' })
export class ResidenceService {
  private apiV1: string = environment.apiV1;
  private baseRef: string = environment.origin;
  private serviceRef: string = environment.service.core;

  constructor(
    private httpClient: HttpClient
  ) { }

  public getOne(residenceId: string): Observable<Residence> {
    return this.httpClient.get<Residence>(`${this.baseRef}${this.serviceRef}${this.apiV1}residences/${residenceId}`);
  }

  public getAll(): Observable<Residence[]> {
    return this.httpClient.get<Residence[]>(`${this.baseRef}${this.serviceRef}${this.apiV1}residences`);
  }

}
